export const searchIfscThroughBranchIdBody = (data) => {
  return {
    bankId: data?.bankId,
    cityId: data?.cityId,
    branchId: data?.branchId,
  }
}

export const returnMobile = (data) => {
  return data?.mobile ?? '917253046336'
}
